<template>
    <select v-model="selected" ref="input"
            class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm"
    >
        <option v-if="defaultText !== null" :value="defaultValue" disabled selected>
            {{ defaultText }}
        </option>

        <option
            v-for="option in options"
            :value="option[optionKey]"
        >
            {{ option[optionValue] }}
        </option>
    </select>
</template>

<script>
export default {
    props: {
        value: {
            default: null,
        },

        options: Array,

        optionKey: {
            type: String,
            default: 'key'
        },

        optionValue: {
            type: String,
            default: 'value'
        },

        defaultText: {
            type: String,
            default: 'Select...'
        },

        defaultValue: {
            type: String,
            default: ''
        },
    },

    computed: {
        selected: {
            get() {
                return this.value
            },

            set(v) {
                this.$emit('input', v)
            }
        }
    },

    methods: {
        focus() {
            this.$refs.input.focus()
        }
    }
}
</script>

